// frontend/src/components/ModalHotkeys.jsx
// Raccourcis clavier génériques pour TOUTES les modales de l'appli (25+
// fichiers différents affichent une modale) : Entrée valide, Échap annule —
// sans avoir à câbler quoi que ce soit dans chaque modale une par une.
//
// Fonctionne par introspection du DOM plutôt que par contexte React, parce
// que chaque modale de l'appli suit déjà la même convention stricte :
//   <div className="modal-overlay" onClick={e => e.target===e.currentTarget && onClose()}>
//     <div className="modal"> ... boutons ... </div>
//   </div>
// On peut donc génériquement retrouver "la modale au-dessus" (la dernière du
// DOM — les modales imbriquées se montent après leur parent) et reproduire
// exactement un clic sur le fond pour Échap, ou cliquer son bouton d'action
// principal pour Entrée.
//
// Pour éviter un double déclenchement, les champs qui gèrent déjà eux-mêmes
// la touche Entrée (navigation entre champs, recherche…) appellent
// e.stopPropagation() dans leur propre onKeyDown — l'événement natif ne
// remonte alors jamais jusqu'à ce composant.
import { useEffect } from 'react';

export default function ModalHotkeys() {
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key !== 'Enter' && e.key !== 'Escape') return;

      const overlays = document.querySelectorAll('.modal-overlay');
      if (overlays.length === 0) return;
      const topOverlay = overlays[overlays.length - 1];

      if (e.key === 'Escape') {
        e.preventDefault();
        // Reproduit un clic sur le fond : dispatché directement sur
        // l'overlay, target === currentTarget, exactement comme un vrai
        // clic backdrop — déclenche donc le onClose()/onCancel() existant.
        topOverlay.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
        return;
      }

      // Entrée : jamais dans un textarea (retour à la ligne voulu), et pas
      // sur un bouton déjà focus (le navigateur l'active tout seul).
      const active = document.activeElement;
      if (active?.tagName === 'TEXTAREA' || active?.tagName === 'BUTTON') return;

      const modal = topOverlay.querySelector('.modal');
      if (!modal) return;

      // Bouton d'action principal : dernier bouton non désactivé qui n'est
      // pas explicitement "secondaire" (Annuler/Fermer) — dans toutes les
      // modales de l'appli, ce bouton est affiché après le bouton Annuler.
      let target = null;
      for (const btn of modal.querySelectorAll('button:not(:disabled)')) {
        const cls = btn.className || '';
        if (cls.includes('btn-secondary') || cls.includes('btn-ghost')) continue;
        target = btn;
      }
      if (target) {
        e.preventDefault();
        target.click();
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);

  return null;
}

